"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Site = _interopRequireDefault(require("@rsuite/icon-font/lib/layout/Site"));

// Generated by script, don't edit it please.
var Site = (0, _createSvgIcon["default"])({
  as: _Site["default"],
  ariaLabel: 'site',
  category: 'layout',
  displayName: 'Site'
});
var _default = Site;
exports["default"] = _default;
module.exports = exports.default;